import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { FileStack, Paperclip } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

const AttachmentProcessorNode = ({ data, selected }: NodeProps) => {
    return (
        <BaseNodeUI
            title={data?.label || "Attachment Processor"}
            icon={Paperclip}
            colorClass="text-slate-600"
            bgClass="bg-slate-100"
            selected={selected}
            isRunning={data?.executionStatus === 'Running'} executionStatus={data?.executionStatus}
            rowsProcessed={data?.rowsAffected}
        />
    );
};

export default memo(AttachmentProcessorNode);
